import { render, staticRenderFns } from "./StepScale.vue?vue&type=template&id=4f5d33ce&scoped=true&"
import script from "./StepScale.vue?vue&type=script&lang=js&"
export * from "./StepScale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5d33ce",
  null
  
)

export default component.exports